import React, {Component} from 'react';
import _ from 'lodash';
import classNames from 'classnames';
import I18n from 'PMT/i18n/I18n';
import RestaurantMenuAction from 'actions/RestaurantMenuAction';

export default class SynchronizeMenuView extends Component {

  constructor(props) {
    super(props)
  }

  onSynchronize = (event: Event) => {
    event.preventDefault();
    this.props.setLoading();
    RestaurantMenuAction.loadRestaurantMenuWithSynchronization()
  };

  //
  //
  //

  renderLastSyncDate() {
    if (_.isNull(this.props.apiError)
        || _.isNull(this.props.restaurantMenu) || _.isNull(
            this.props.restaurantMenu.posSyncDate)) {
      return (null);
    }

    return (
        <div>
          {this.props.restaurantMenu.posSyncDate.format('DD/MM - HH:mm')}
        </div>
    );
  }

  renderApiError() {
    if (_.isNull(this.props.apiError)) {
      return (null);
    }

    const shouldDisplayPmtErrorMessage = this.props.apiError.code !== "419" // is not "POS_NOT_RESPONDING"
        && this.props.apiError.extra
        && this.props.apiError.extra.pmtErrorMessage

    return (
        <div>
          {this.renderLastSyncDate()}
          <div style={{maxWidth: '500px', textAlign: 'right'}}>
            <i className="fa fa-warning"/>
            <span>&nbsp;&nbsp;{shouldDisplayPmtErrorMessage
                ? this.props.apiError.extra.pmtErrorMessage : I18n.tr(
                    'menu.pos_connection_loss.tooltip')}</span>
            <div style={{
              fontStyle: "italic",
              fontSize: '0.8em',
              marginTop: '5px'
            }}>{'sessionId: '
                + this.props.apiError.getSessionId()}</div>
          </div>
        </div>
    );
  }

  render() {
    const isLoading = this.props.isLoading
    // a menu not yet existing (eg. when the store has just been created, and the sync has never been made) should not be displayed as an error
    const displayAsError = !_.isNull(this.props.apiError)
        && this.props.apiError.code !== "404"

    const className = classNames('btn', {
      'btn-primary': !displayAsError,
      'btn-danger': displayAsError,
    });

    return (
        <div className="synchronize_menu_view pull-right"
             style={{textAlign: 'right'}}>
          <button
              className={className}
              onClick={this.onSynchronize}
              disabled={isLoading}
          >
            {isLoading && (
                <span>
              <i className="fa fa-spinner fa-spin"/>
                  &nbsp;&nbsp;
            </span>
            )}
            {I18n.tr('menu.synchronize_with_pos')}
          </button>

          {displayAsError && this.renderApiError()}
        </div>
    );
  }

}
